<template>
    <div class="advanced-search__filters-section">
        <div class="advanced-search__filters-section-label">
            <h4 class="advanced-search__label">Colour</h4>
        </div>
        <div class="advanced-search__filters-section-content advanced-search__filters-section-content--colours">
            <template v-for="(option, index) in availableOptions">
                <div :key="index">
                    <input class="redesign-checkbox__input advanced-search__filters-section-colour-checkbox" type="checkbox" :id="uid + index" :value="option.value" v-model="selectedValue" />
                    <label class="advanced-search__filters-section-colour-label" :for="uid + index" :title="option.label"><div class="advanced-search__filters-colour" :title="option.label" :style="option.colour"></div></label>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    computed: {
        ...mapGetters({
            userOptions: 'UsedSearchOptions/userOptions',
        }),
        availableOptions() {
            const availableOptions = this.$store.state.UsedSearchOptions.options.colour;
            if (!availableOptions) {
                return [];
            }

            return availableOptions.map(availableOption => {
                if (availableOption == null) {
                    return {
                        value: 'Unlisted',
                        colour: {background: 'linear-gradient(90deg, rgba(255,0,0,1) 0%, rgba(255,235,0,1) 15%, rgba(56,255,0,1) 33%, rgba(0,255,213,1) 50%, rgba(0,33,242,1) 65%, rgba(199,0,248,1) 82%, rgba(255,0,0,1) 100%);'},
                        label: 'Unlisted',
                    };
                }
                const length = availableOption.length;
                return {
                    value: availableOption,
                    colour: {['background-color']: '#' + availableOption.substring(length -7, length -1)},
                    label: availableOption.substring(0, length - 8),
                };
            });
        },
        selectedValue: {
            get() {
                return this.userOptions.colour;
            },
            set (value) {
                this.$store.dispatch('UsedSearchOptions/updateOptions', {
                    colour: value,
                });
            }
        },
        uid() {
            return 'colour.' + this._uid;
        }
    },
}
</script>

<style lang="scss">
.advanced-search {
    &__filters-section-label {
        margin-bottom: 10px;
    }

    &__filters-section-content--colours {
        display: grid;
        grid-template-columns: repeat(auto-fill, 45px);
        gap: 14px 20px;
    }

    &__filters-section-colour-label {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 45px;
        height: 45px;
        border: 1px solid #9B9B9B;
        border-radius: 45px;
        background-color: #fff;
        position: relative;
        cursor: pointer;
    }

    &__filters-colour {
        width: 25px;
        height: 25px;
        border-radius: 25px;
        // background-color: $blue;
        &--Multicolour {
            background: linear-gradient(90deg, rgba(255,0,0,1) 0%, rgba(255,235,0,1) 15%, rgba(56,255,0,1) 33%, rgba(0,255,213,1) 50%, rgba(0,33,242,1) 65%, rgba(199,0,248,1) 82%, rgba(255,0,0,1) 100%);
        }
    }

    &__filters-section-colour-checkbox:checked + .advanced-search__filters-section-colour-label {
        border: 1px solid #0093D6;
        box-shadow: 0 0 4px 0 #0092D9;
    }
}
</style>


// WEBPACK FOOTER //
// resources/assets/js/used-vue/components/UsedLandingSearchBoxColourFilter.vue